import { z } from 'zod';
/**
 * The request that confirms the API is up, watched by the uptime checker
 * (`patterns/error-handling.md`, 9). Public, and returns no data. When the
 * database query fails the API answers with the standard error envelope and
 * code `INTERNAL`, so there is exactly one failure shape (`technical.md`, D7).
 */
export const healthResponseSchema = z.object({});
export const health = {
    method: 'GET',
    path: '/api/dashboard/health',
    params: z.object({}),
    query: z.object({}),
    body: z.object({}),
    response: healthResponseSchema,
};
//# sourceMappingURL=health.js.map